'use client';

import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  // Rendered inside AppShell's <main>, which already reserves the top bar and dock insets,
  // so fill that content box (min-h-full) instead of the viewport, as not-found.tsx does.
  return (
    <div className="flex min-h-full items-center justify-center px-4 py-8">
      <div className="w-full max-w-md space-y-6 rounded-feature border border-[var(--ss-border)] bg-[var(--ss-surface)] p-7 text-center sm:p-8">
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-[0.22em] text-[var(--ss-brand)]">Recovery</p>
          <h1 className="mt-2 text-3xl font-bold text-[var(--ss-text)]">Something went wrong</h1>
          <p className="mt-3 text-sm leading-6 text-[var(--ss-text-muted)]">
            An unexpected error occurred. Try refreshing — if it keeps happening, let us know.
          </p>
          {error.digest && (
            <p className="font-mono text-xs text-[var(--ss-text-muted)]">
              Error ID: {error.digest}
            </p>
          )}
        </div>
        <div className="flex flex-col justify-center gap-3 sm:flex-row">
          <button
            onClick={reset}
            className="min-h-12 rounded-card bg-[var(--ss-brand-solid)] px-6 py-3 text-sm font-semibold text-[var(--ss-brand-contrast)] transition hover:bg-[var(--ss-brand-strong)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ss-focus)] focus-visible:ring-offset-2"
          >
            Try again
          </button>
          <a
            href="/"
            className="min-h-12 rounded-card border border-[var(--ss-border)] bg-[var(--ss-surface)] px-6 py-3 text-sm font-semibold text-[var(--ss-text)] transition hover:bg-[var(--ss-surface-subtle)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--ss-focus)]"
          >
            Go home
          </a>
        </div>
      </div>
    </div>
  );
}
